module.exports = __webpack_public_path__ + "8cfa7ba12f0b8a7f225c60e91c757f5e.svg";